import {Component, OnInit, Output} from '@angular/core';
import {isMobile} from '../../../utils/utils';
import {DeviceService} from '../../../../shared/services/device.service';
import {AztecScannerService} from '../../../../shared/services/aztec-scanner.service';
import {WizardService} from '../../../services/wizard.service';
import {NextBannersService} from '../../../../shared/services/next-banners.service';
import {NextBannerConfig} from '../../../models/next-banners-config';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: []
})
export class BannerComponent implements OnInit {

  get imageSrc(): string {
    return './assets/images/banner-car.webp';
  }

  get aztecScannerImageSrc(): string {
    return './assets/images/banner-aztec-scanner.webp';
  }

  get aztecScannerBannerVisible(): boolean {
    return !this.wizardService.isDiagnosticStationContext && this.wizardService.isOcDetailsStep && isMobile();
  }

  get banner(): NextBannerConfig {
    return this.bannersService.getStepBannerConfig(this.wizardService.currentStepKey);
  }

  constructor(private deviceService: DeviceService,
              private wizardService: WizardService,
              private bannersService: NextBannersService,
              private aztecScannerService: AztecScannerService) { }

  ngOnInit() {
  }

  scan() {
    if (this.deviceService.isMobileDevice) {
      this.aztecScannerService.openAztecScanner();
    } else {
      this.aztecScannerService.openAztecScannerQRDialog();
    }
  }

}
